<template>
  <div>404了，你自己想想办法，我不想提供方法带你出去，等我想带你出去再写</div>
</template>

<script>
export default {
  components: {},
  name: 'notFound',
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},

  methods: {}
}
</script>

<style>
.testbox {
  width: 200px;
  height: 200px;
}
</style>
